import { render, staticRenderFns } from "./CopyURLButton.vue?vue&type=template&id=10b7848e&scoped=true"
import script from "./CopyURLButton.vue?vue&type=script&lang=ts"
export * from "./CopyURLButton.vue?vue&type=script&lang=ts"
import style0 from "./CopyURLButton.vue?vue&type=style&index=0&id=10b7848e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b7848e",
  null
  
)

export default component.exports